import React from 'react';
import { useForm, usePage } from '@inertiajs/react';
import { Button } from '../../components/ui/button';
import { Input } from '../../components/ui/input';
import ValidationError from '../../components/ValidationError';
import { useTrans } from '../../hooks/useTrans';
import ProfileTabs from './components/ProfileTabs';

export default function Password({ user, pageTranslations }) {
    const translate = useTrans();
    const { routes } = usePage().props;
    const isFederated = !!user.identityProviderId;

    const { data, setData, put, processing, errors } = useForm({
        current_password: '',
        password: '',
        password_confirmation: '',
    });

    function handleSubmit(e) {
        e.preventDefault();
        put(routes.profileUpdate);
    }

    return (
        <div className="max-w-[1200px] mx-auto px-4">
            <ProfileTabs />
            <div className="rounded-[3px] rounded-tl-none border border-[#bbb] bg-white">
                <div className="p-[30px]">
                    {isFederated && (
                        <div className="mb-6 rounded border border-[#bce8f1] bg-[#d9edf7] p-4 text-sm text-[#31708f]">
                            <h5 className="font-bold mb-1">{pageTranslations.federatedTitle}</h5>
                            <p>{pageTranslations.federatedMessage}</p>
                        </div>
                    )}

                    <form onSubmit={handleSubmit}>
                        <h3 className="text-2xl font-bold text-[#003545] mb-4">
                            {translate('Wachtwoord')}
                        </h3>

                        <div className="space-y-4">
                            <div className="flex flex-col sm:flex-row sm:items-center">
                                <label className="sm:w-[217px] shrink-0 text-sm font-bold text-[#003545] mb-1 sm:mb-0" htmlFor="current_password">
                                    {translate('Huidig wachtwoord')}&nbsp;<sup>*</sup>
                                </label>
                                <div className="w-full sm:w-[352px]">
                                    <Input
                                        id="current_password"
                                        type="password"
                                        value={data.current_password}
                                        onChange={(e) => setData('current_password', e.target.value)}
                                        required
                                        disabled={isFederated}
                                        className="h-[44px] font-normal"
                                    />
                                    <ValidationError message={errors.current_password} />
                                </div>
                            </div>

                            <div className="flex flex-col sm:flex-row sm:items-center">
                                <label className="sm:w-[217px] shrink-0 text-sm font-bold text-[#003545] mb-1 sm:mb-0" htmlFor="password">
                                    {translate('Nieuw wachtwoord')}&nbsp;<sup>*</sup>
                                </label>
                                <div className="w-full sm:w-[352px]">
                                    <Input
                                        id="password"
                                        type="password"
                                        value={data.password}
                                        onChange={(e) => setData('password', e.target.value)}
                                        required
                                        disabled={isFederated}
                                        className="h-[44px] font-normal"
                                    />
                                    <ValidationError message={errors.password} />
                                </div>
                            </div>

                            <div className="flex flex-col sm:flex-row sm:items-center">
                                <label className="sm:w-[217px] shrink-0 text-sm font-bold text-[#003545] mb-1 sm:mb-0" htmlFor="password_confirmation">
                                    {translate('Herhaal nieuw wachtwoord')}&nbsp;<sup>*</sup>
                                </label>
                                <div className="w-full sm:w-[352px]">
                                    <Input
                                        id="password_confirmation"
                                        type="password"
                                        value={data.password_confirmation}
                                        onChange={(e) => setData('password_confirmation', e.target.value)}
                                        required
                                        disabled={isFederated}
                                        className="h-[44px] font-normal"
                                    />
                                    <ValidationError message={errors.password_confirmation} />
                                </div>
                            </div>
                        </div>

                        <hr className="my-7 border-[#ddd]" />

                        <div className="flex justify-end">
                            <Button variant="primary" type="submit" disabled={processing || isFederated}>
                                {translate('Opslaan')}
                            </Button>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    );
}
